import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    identifier: String
  }

  open(e) {
    // The header search icon is global, but the filter modal (#def) may or may
    // not be on the page. On the results page it's the inline modal; elsewhere
    // it's the preloaded cold modal in the layout (once search-modal-loader has
    // injected it). Either way, open it in place. If it isn't here yet — or the
    // cold modal is being opened on desktop, where it's a mobile-only overlay —
    // do nothing and let the link navigate to /videos?open_search=1, where
    // modal-filters#connect opens it on arrival.
    const host = document.querySelector(`#${this.identifierValue}`);
    if (!host || !host.modal) return;
    if (host.dataset.coldModal && !window.matchMedia("(max-width: 767px)").matches) return;
    host.modal.open(e);
  };
}
